export function poUrl(id) { return `/logistics/purchasing/${id}`; }
export function routeUrl(id) { return `/logistics/routes/${id}`; }
export function deliveryUrl(id) { return `/logistics/packing/${id}`; }
